<div class="action-queues">
  <div class="buttons" *ngIf="!loading.queues">
    <button class="vox-btn vox-btn-secondary" (click)="restartQueues()" [ladda]="restartLoading"
      data-spinner-color="white" data-style="zoom-in" [disabled]="queues?.length === 0 || company.readOnly">
      <span translate>company.queues.restart</span>
    </button>
    <button class="vox-btn vox-btn-secondary" (click)="logoutUsersQueue()" [ladda]="logoutUsersLoading"
      data-spinner-color="white" data-style="zoom-in" [disabled]="queues?.length === 0 || company.readOnly">
      <span translate>company.queues.logout</span>
    </button>
  </div>
  <div class="buttons" *ngIf="loading.queues">
    <ngx-skeleton-loader class="vox-btn p-0" [theme]="{'min-width.px': 85, 'min-height.px': 48, 'margin.px': 0}"></ngx-skeleton-loader>
    <ngx-skeleton-loader class="vox-btn p-0" [theme]="{'min-width.px': 85, 'min-height.px': 48, 'margin.px': 0}"></ngx-skeleton-loader>
  </div>

  <div class="new-queue-module vox-input-group mb-0" *ngIf="!loading.queueModule">
    <label translate>company.queues.module-label</label>
    <div class="d-flex flex-column">
      <div ngbDropdown class="vox-dropdown-input">
        <button id="queue module" ngbDropdownToggle>
          <span>{{queueModule | noUnderscore }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="queue module">
          <button ngbDropdownItem *ngFor="let m of queueModules" (click)="selectQueueModule(m)" >{{m | noUnderscore}}</button>
        </div>
      </div>
      <button class="vox-btn vox-icon vox-btn-secondary mt-2"
        *ngIf="someSelected"
        (click)="changeQueueModule()"
        data-spinner-color="white"
        data-style="zoom-in">
        <i class="icon-small-back"></i>
        {{'company.queues.tooltip.change-module' | translate}}
      </button>
    </div>
  </div>

  <div *ngIf="loading.queueModule" class="new-queue-module">
    <ngx-skeleton-loader class="d-block" [theme]="{'width.px': 110, 'height.px': 20, 'margin-bottom.px': 0 }"></ngx-skeleton-loader>
    <ngx-skeleton-loader class="d-block vox-dropdown-input" [theme]="{'width.px': 150, 'height.px': 40, 'margin-bottom.px': 0, 'min-width': '100%' }"></ngx-skeleton-loader>
  </div>
</div>

<div class="vox-table company-queues">
  <table>
    <thead>
      <tr>
        <td class="select-cell">
          <input class="vox-checkbox"
            type="checkbox"
            *ngIf="!loading.queues"
            [disabled]="loading.queues || queues.length === 0"
            [checked]="everySelected"
            (click)="toggleSelectAll()" />
          <ngx-skeleton-loader *ngIf="loading.queues" [theme]="{'width.px': 25, 'height.px': 25, 'margin': 0}"></ngx-skeleton-loader>
        </td>
        <td translate>company.queues.name</td>
        <td translate>company.queues.module</td>
        <td translate>company.queues.ring</td>
        <td translate>company.queues.user</td>
        <td translate>company.queues.automatic-recreate <i class="icon-small-info" [ngbTooltip]="'company.queues.tooltip.automatic-recreation' | translate"></i></td>
        <td translate>company.queues.actions</td>
      </tr>
    </thead>
    <tbody *ngIf="!loading.queues">
      <tr *ngFor="let q of queues">
        <td class="select-cell">
          <input class="vox-checkbox" type="checkbox" [checked]="q._selected" (click)="toggleSelect(q)"/>
        </td>
        <td>
          <div class="queue">
            <span class="queue__name">{{q.name}}</span>
          </div>
        </td>
        <td>
          <span class="vox-chip vox-chip_aquamarine-text">{{q.module | noUnderscore}}</span>
        </td>
        <td>
          <span>{{ 'company.queues.ring-strategy-popup.options.' + q.user_strategy.toLowerCase() + '.label' | translate }}</span>
        </td>
        <td>
          <ul class="users-list">
            <li class="users-list__item" *ngFor="let u of q.users">
              <div class="user">
                <span [innerHTML]="getUserQueue(u.id)" class="user__name"></span>
                <div class="user__actions">
                  <button class="vox-btn btn btn-warning" [ngbTooltip]="'company.queues.tooltip.login' | translate"
                    (click)="loginUserQueue(u)"
                    [ladda]="u._login"
                    [disabled]="q.module === 'RING_GROUP'"
                    data-spinner-color="white"
                    data-style="zoom-in">
                    <i class="fas fa-sign-in-alt"></i>
                  </button>
                  <button class="vox-btn btn btn-danger"
                    [ngbTooltip]="'company.queues.tooltip.logout' | translate"
                    (click)="logoutUserQueue(u)"
                    [ladda]="u._logout"
                    [disabled]="q.module === 'RING_GROUP'"
                    data-spinner-color="white"
                    data-style="zoom-in">
                    <i class="fas fa-sign-out-alt"></i>
                  </button>
                </div>
              </div>

            </li>
          </ul>
        </td>
        <td class="toggle-container">
          <vox-toggle  class="vox-toggle"
            *ngIf="!q._automaticRecreating"
            [config]="{ disabled: q.module === 'RING_GROUP' , isAquamarine: true }"
            [toggleOn]="q.is_recreatable"
            (toggleOnChange)="onAutomaticRecreateToggle($event, q)">
          </vox-toggle>
          <button class="ladda-mock"
            *ngIf="q._automaticRecreating"
            disabled="disabled"
            [ladda]="true"
            data-spinner-color="black"
            data-spinner-size="24"
            data-style="zoom-in"></button>
        </td>

        <td>

          <button class="vox-btn btn btn-warning"
            [ngbTooltip]="'company.queues.tooltip.change-module' | translate"
            (click)="changeQueueModule(q)"
            [ladda]="q._loading"
            data-spinner-color="white"
            data-style="zoom-in">
            <i class="icon-small-edit"></i>
          </button>

          <button class="vox-btn btn btn-warning"
            [ngbTooltip]="'company.queues.tooltip.ring-strategy' | translate"
            (click)="selectRingStrategy(q)"
            [ladda]="q._loading"
            data-spinner-color="white"
            data-style="zoom-in">
            <i class="icon-small-call-ring"></i>
          </button>

          <button class="vox-btn btn btn-warning"
            [ngbTooltip]="'company.queues.tooltip.resolve-conflicts-queue' | translate"
            (click)="resolveConflictsQueue(q)"
            [ladda]="q._resolveConflicts"
            [disabled]="q.module === 'RING_GROUP'"
            data-spinner-color="white"
            data-style="zoom-in">
            <i class="fas fa-wrench"></i>
          </button>

          <button class="vox-btn btn btn-warning"
            [ngbTooltip]="'company.queues.tooltip.recreate-queue' | translate"
            (click)="recreateQueue(q)"
            [ladda]="q._recreating"
            [disabled]="q.module === 'RING_GROUP'"
            data-spinner-color="white"
            data-style="zoom-in">
            <i class="fas fa-sync-alt"></i>
          </button>
        </td>

      </tr>
    </tbody>
    <tbody *ngIf="loading.queues">
      <tr *ngFor="let i of [1,2,3,4]">
        <td colspan="8">
          <ngx-skeleton-loader></ngx-skeleton-loader>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="!loading.queues && queues.length === 0">
      <tr>
        <td colspan="8" translate>company.queues.empty</td>
      </tr>
    </tbody>
  </table>
</div>
